import Button from "@/components/atom/Button";
import { ScrollPagination } from "@/components/atom/Pagination";
import useDelayedRender from "@/functions/useDelayedRender";
import { BlurImage } from "@/public/images";
import Image from "next/image";
import Link from "next/link";
import { useState } from "react";

export default function DescProduct({ item, handleDownload, loading }) {
  const shouldRendered = useDelayedRender(1000);

  const [showDesc, setShowDesc] = useState("Deskripsi Produk");
  return (
    shouldRendered && (
      <div className='w-full'>
        <ScrollPagination
          datas={[
            {
              title: "Deskripsi Produk",
              id: "deskripsi-produk",
            },
            {
              title: "Size Chart",
              id: "size-chart-produk",
            },
          ]}
          className={"flex w-fit"}
          renderItem={({ item, index }) => (
            <div
              key={index}
              id={item?.id}
              onClick={() => setShowDesc(item?.title)}
              className={`${
                showDesc == item?.title ? "bg-greyscaleGON-50" : ""
              } py-3 px-4 overflow-hidden rounded-t-sm`}>
              <p
                className={`text-button-medium text-${
                  showDesc == item?.title ? "primary" : "greyscale"
                }GON-400  whitespace-nowrap overflow-hidden text-ellipsis`}>
                {item?.title}
              </p>
            </div>
          )}
        />
        {showDesc == "Deskripsi Produk" ? (
          <div className='flex flex-col  bg-greyscaleGON-50 py-3 px-4'>
            <div className='my-4'>
              <p className='subheading-semiBold text-greyscaleGON-700'>
                Deskripsi Produk
              </p>
            </div>
            <div
              className='p1-regular  text-greyscaleGON-700 whitespace-pre-line overflow-hidden overflow-x-scroll'
              dangerouslySetInnerHTML={{ __html: item?.description }}
            />
          </div>
        ) : (
          <div className='flex flex-col  bg-greyscaleGON-50 py-3 px-4'>
            <div className='my-4'>
              <p className='subheading-semiBold text-greyscaleGON-700'>
                Size Chart
              </p>
            </div>
            <div className='p1-regular  text-greyscaleGON-500 whitespace-pre-line overflow-hidden overflow-x-scroll'>
              {!item?.thumbnails_size_cart ? (
                <p className='capitalize'>tidak ditemukan</p>
              ) : (
                <>
                <Link
                  aria-label={"shize-chart"}
                  as={item?.thumbnails_size_cart ?? BlurImage}
                  shallow
                  href={item?.thumbnails_size_cart ?? BlurImage}
                  target='_blank'
                  className='w-full h-full'>
                  <Image
                    src={item?.thumbnails_size_cart}
                    alt={`thumbnails_size_cart`}
                    className='w-auto h-auto object-cover object-top'
                    width={320}
                    height={320}
                    placeholder='blur'
                    blurDataURL={BlurImage?.blurDataURL}
                  />
                </Link>
                <Button label="Download Size Chart" disable={loading?.download} loading={loading?.download} onClick={() => handleDownload(false, "jpeg", item?.thumbnails_size_cart, 'size-chart')} className="w-fit mt-4" variants="outline"/>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    )
  );
}
